import React from 'react';

function Contact() {
  return <section className="tc-contact-style4"></section>;
}

export default Contact;
